
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[id]/[slug]",
      function () {
        return require("private-next-pages/shop/[id]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[id]/[slug]"])
      });
    }
  